import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormControl, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatError, MatFormField, MatHint, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";
import {DialogBaseComponent} from "../dialog-base/dialog-base.component";

export interface IVoidPayoutRuleVersionData {
  /** The version's date as the change history shows it. */
  effectiveFrom: string;
}

/** Collects the reason a Causable admin voids a payout rule version; closes with the reason, or false. */
@Component({
  selector: 'app-void-payout-rule-version',
  standalone: true,
  imports: [DialogBaseComponent, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatHint, MatError, MatButton],
  templateUrl: './void-payout-rule-version.component.html'
})
export class VoidPayoutRuleVersionDialogComponent {
  /** Matches the varchar(500) void_reason column. */
  public readonly reasonMaxLength = 500;

  private dialogRef = inject(MatDialogRef<VoidPayoutRuleVersionDialogComponent>);
  public data: IVoidPayoutRuleVersionData = inject(MAT_DIALOG_DATA);

  public reasonControl = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required, Validators.maxLength(this.reasonMaxLength)]
  });

  get canVoid(): boolean {
    return this.reasonControl.valid && this.reasonControl.value.trim().length > 0;
  }

  voidVersion(): void {
    if (!this.canVoid) {
      this.reasonControl.markAsTouched();
      return;
    }

    this.dialogRef.close(this.reasonControl.value.trim());
  }
}
